import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class AuthorizedGuardService implements CanActivate {
	constructor(private authService: AuthService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
		const authenticated$ = this.authService.isAuthenticated$;

		return authenticated$.pipe(
			tap((loggedIn) => {
				if (!loggedIn) {
					this.authService.loginWithRedirect({ appState: { target: state.url } });
				}
			}),
		);
	}
}
